import { createPublicHeadDescriptor, } from "@logscord/public-site/seo";
import { DefaultLogscordPublicDefaultImagePath, LogscordPublicSite, } from "./manifest.js";
import { createLogscordSiteIdentity } from "./siteIdentity.js";
export function createLogscordHeadDescriptor(options) {
    const site = options.site ?? LogscordPublicSite;
    return createPublicHeadDescriptor({
        site: createLogscordSiteIdentity(options.siteUrl, options.defaultImage ?? DefaultLogscordPublicDefaultImagePath),
        path: site.normalizePath(options.path),
        htmlLang: options.htmlLang ?? site.getLocaleFromPath(options.path) ?? site.defaultLocale,
        title: options.title,
        description: options.description,
        canonicalPath: options.canonicalPath,
        indexing: options.indexing,
        image: options.image,
        alternates: options.alternates,
        structuredData: options.structuredData,
    });
}
//# sourceMappingURL=seo.js.map